export const MAIN_POOL_ID = 0;
export const JLP_POOL_ID = 1;
export const LST_POOL_ID = 2;
export const EXPONENT_POOL_ID = 3;
export const SACRED_POOL_ID = 4;
